import {BooleanNumField} from '@/components/field'
import {getProducerStoreLink} from '@/lib/link'
import {ProducerStore} from '@/types'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import {Chip, IconButton} from '@mui/material'
import {formatNumber} from 'chart.js/helpers'
import * as React from 'react'
import {ReactNode} from 'react'
import {Datagrid, DatagridProps, EditButton, FunctionField, ReferenceField, ShowButton, TextField} from 'react-admin'

const DatagridActionsColumn = ({label, children}: {
	label: string | ReactNode,
	children: ReactNode
}) => <>{children}</>

export default function DatagridStores(props: DatagridProps) {
	return (
		<Datagrid
			optimized
			rowClick="edit"
			{...props}
		>
			<TextField source="id" label="Identifiant"/>
			<TextField label="Nom" source="name"/>
			{/*<TextField label="Nom" source="lastName"/>*/}
			<TextField label="Email" source="email"/>
			<TextField label="Téléphone" source="phone"/>
			{/*<DateField label="Date de création" source="created_at"/>*/}
			{/*<DateField label="Dernière mise à jour" source="updated_at"/>*/}
			{/*<FunctionField*/}
			{/*    source="is_validated"*/}
			{/*    label="Compte validé"*/}
			{/*    render={(record: any, source: any) =>*/}
			{/*        <BooleanNumField*/}
			{/*            label="Publié"*/}
			{/*            source={source}*/}
			{/*        />*/}
			{/*    }*/}
			{/*/>*/}
			{/*<ReferenceField source="commune" reference="communes" label="Commune">*/}
			{/*	<FunctionField*/}
			{/*		source="is_direct_selling"*/}
			{/*		label="Vente direct"*/}
			{/*		render={(record: Commune) =>*/}
			{/*			<span>{record.name}, {record.zipcode}</span>*/}
			{/*		}*/}
			{/*	/>*/}
			{/*</ReferenceField>*/}
			<FunctionField
				source="is_direct_selling"
				label="Vente direct"
				render={(record: any, source: any) =>
					<BooleanNumField
						label="Publié"
						source={source}
					/>
				}
			/>
			<FunctionField
				source="is_organic"
				label="Bio"
				render={(record: any, source: any) =>
					<BooleanNumField
						label="Publié"
						source={source}
					/>
				}
			/>
			<FunctionField
				source="is_vad"
				label="VAD"
				render={(record: any, source: any) =>
					<BooleanNumField
						label="VAD"
						source={source}
					/>
				}
			/>
			<FunctionField
				source="website"
				label="Site internet"
				render={(record: ProducerStore) => {
					if (!record.website) return null
					return (
						<a
							href={record.website}
							target="_blank"
							rel="noopener noreferrer"
							style={{textDecoration: 'none', color: '#1976d2'}}
							onClick={(e) => e.stopPropagation()}
						>
							{record.website.length > 30 ? `${record.website.substring(0, 30)}...` : record.website}
						</a>
					)
				}}
			/>
			<FunctionField
				source="administrative_status"
				label="Statut SIRENE"
				render={(record: ProducerStore) => {
					if (!record.administrative_status) return null
					const isActive = record.administrative_status === 'A'
					return (
						<Chip
							label={isActive ? 'Actif' : 'Fermé'}
							color={isActive ? 'success' : 'error'}
							size="small"
							variant="outlined"
						/>
					)
				}}
			/>
			<FunctionField
				source="effectifs"
				label="Effectifs"
				render={(record: ProducerStore) => {
					if (!record.effectifs && record.effectifs !== 0) return '-'
					return record.effectifs.toString()
				}}
			/>
			<ReferenceField
				source="producer"
				reference="producers"
				label="Capital social"
				link={false}
				sortBy={'capital_social'}
			>
				<FunctionField
					source="capital_social"
					render={(record: ProducerStore) => {
						if (!record || !record.capital_social) return '-'
						return formatNumber(record.capital_social, 'fr', {style: 'currency', currency: 'EUR'})
					}}
				/>
			</ReferenceField>
			{/*<FunctionField*/}
			{/*	source="image"*/}
			{/*	label="A des médias"*/}
			{/*	render={(record: ProducerStore) => {*/}
			{/*		const hasMedia = record.image && record.image !== null*/}
			{/*		return (*/}
			{/*			<Chip*/}
			{/*				label={hasMedia ? 'Oui' : 'Non'}*/}
			{/*				color={hasMedia ? 'success' : 'default'}*/}
			{/*				size="small"*/}
			{/*				variant="outlined"*/}
			{/*			/>*/}
			{/*		)*/}
			{/*	}}*/}
			{/*/>*/}
			{/*<TextField source="code_ape" label="Code APE"/>*/}
			{/*<DateField source="cessation_date" label="Date de cessation" showTime={false}/>*/}
			{/*<DateField source="sirene_last_update" label="Dernière sync SIRENE" showTime={true}/>*/}
			<DatagridActionsColumn
				label=""//{<LinkUserDialog/>}
			>
				<ShowButton/>
				<EditButton/>
				<FunctionField
					source="is_organic"
					label="Bio"
					render={(record: ProducerStore) =>
						<IconButton
							target="_blank"
							href={getProducerStoreLink(record)}
							color="primary"
							aria-label="View"
						>
							<OpenInNewIcon/>
						</IconButton>
					}
				/>
			</DatagridActionsColumn>
		</Datagrid>
	)
}
